/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_Org_TitleInputs */

const cs_portals_org_title = /** @type {(inputs: Portals_Org_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stav syncu portálů`)
};

const en_portals_org_title = /** @type {(inputs: Portals_Org_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portal sync status`)
};

/**
* | output |
* | --- |
* | "Portal sync status" |
*
* @param {Portals_Org_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_org_title = /** @type {((inputs?: Portals_Org_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Org_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_org_title(inputs)
	return cs_portals_org_title(inputs)
});